import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import attendantReadAction from './attendantRead.action.json' assert { type: 'json' }

const attendantReadDefinition = defineReadAutoAction(attendantReadAction, 'attendant')

export default attendantReadDefinition
